import { createContext, useContext, type ReactNode } from "react";

/** When true, profile editor controls (toggles, native checkboxes, filter dropdown checks) use brand red (`primary`) instead of blue (`secondary` / Default). */
const ProfileEditorBrandAccentContext = createContext(false);

export function ProfileEditorBrandAccentProvider({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <ProfileEditorBrandAccentContext.Provider value={true}>
      {children}
    </ProfileEditorBrandAccentContext.Provider>
  );
}

export function useProfileEditorBrandAccent(): boolean {
  return useContext(ProfileEditorBrandAccentContext);
}
